export const Colors = {
    primary: '#0d7ed3'
}